// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T_r0r","newExpiryDate":"styles_newExpiryDate__3o5tS","footer":"styles_footer__J1bhh"};